exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".lAJSTyzHP01AeJfljnm8s{font-size:15px;line-height:22px;width:202px;display:flex}.lAJSTyzHP01AeJfljnm8s ._1D3uHL7gEI5XckfqNw7G2L{margin-right:10px}.lAJSTyzHP01AeJfljnm8s ._3TyVQyR1LqKJmDWLYHOk7s{margin-bottom:5px}.lAJSTyzHP01AeJfljnm8s ._3FjEVz7nAgfAw-3bKiPQyz{font-weight:500}\n", ""]);

// Exports
exports.locals = {
	"PhotoPopup": "lAJSTyzHP01AeJfljnm8s",
	"thumb": "_1D3uHL7gEI5XckfqNw7G2L",
	"metaLabel": "_3TyVQyR1LqKJmDWLYHOk7s",
	"metaValue": "_3FjEVz7nAgfAw-3bKiPQyz"
};